import { NavigateFunction } from "react-router-dom";

export const navigateToUtil = (route: string, navigateFn: NavigateFunction, currLocation: string) => {
    if (currLocation.includes("axnadmin") && !route.includes("axnadmin")) {
        navigateFn(`/axnadmin${route}`);
    } else {
        navigateFn(route);
    }
};

export const navigateToUtilWithQueryParameters = (route: string, navigateFn: NavigateFunction, currLocation: string, queryParameters: string) => {
    if (currLocation.includes("axnadmin") && !route.includes("axnadmin")) {
        navigateFn({
            pathname: `/axnadmin${route}`,
            search: queryParameters
        });
    } else {
        navigateFn({
            pathname: route,
            search: queryParameters
        });
    }
};

export const openToNewTabUtil = (route: string, currLocation: string) => {
    if (currLocation.includes("axnadmin") && !route.includes("axnadmin")) {
        window.open(`/axnadmin${route}`, "_blank");
    } else {
        window.open(route, "_blank");
    }
};